import React, {Component} from 'react'
import BackgroundImgSrc from '../images/homepage_bw.jpg';

const ORIGINAL_HEIGHT = 990;
const ORIGINAL_WIDTH = 1087;
const RATIO = ORIGINAL_WIDTH/ORIGINAL_HEIGHT; //width to height
const SIZE_RATIO = 0.9;
const OFFSET_RATIO = 0.05;

export default class Homepage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      h: 500,
      w: 500,
      offset: 0
    }

    this.onResize = this.onResize.bind(this);
    this.toggleLoading = this.toggleLoading.bind(this);
  }

  toggleLoading(bool) {
    this.setState(function() {
      return {
        loading: bool
      }
    });
  }

  componentDidMount() {
    this.props.toggleWork(false);
    this.props.toggleDivider(false);
    this.onResize();
    window.addEventListener('resize', this.onResize);

    let img = new Image();
    img.onload = this.toggleLoading.bind(null, false);
    img.src = BackgroundImgSrc;
  }

  componentWillUnmount() {
    // this.props.toggleDivider(true);
    // this.toggleLoading(true);
  }

  onResize() {
    let h = window.innerHeight;
    let w = window.innerWidth;
    let newH = 0;
    let newW = 0;

    if (h < (w * RATIO)) {
      newH = Math.min(ORIGINAL_HEIGHT, h * SIZE_RATIO);
      newW = newH * RATIO;
    } else {
      newW = Math.min(ORIGINAL_WIDTH, w * SIZE_RATIO);
      newH = newW / RATIO;
    }

    this.setState({
      h: newH,
      w: newW,
      offset: OFFSET_RATIO * w
    });
  }

  render() {
    var imgStyle = {
      height: this.state.h + 'px',
      width: this.state.w + 'px',
      marginLeft: this.state.offset
    }

    return (
      <div className='background'>
        {this.state.loading ?
          null :
          <img
            src={BackgroundImgSrc}
            style={imgStyle}
          />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Homepage.js